module.exports = __webpack_public_path__ + "img/icon18.f8bf80c5.svg";